import {
  GEO,
  IMG,
  JSN,
  KML,
  KMZ,
  PDF,
  PPT,
  PRJ,
  SHP,
  VID,
  XLSX,
  CLOSE,
  DOWNLOAD,
  DOC,
  DOCX,
  TXT,
  RTF,
  ODT,
  HTML,
  HTM,
  MD,
  XLS,
  CSV,
  ODS,
  XLSM,
  XLT,
  XLTX,
  PPTX,
  ODP,
  PPS,
  PPSX,
  KEY,
  POT,
  POTX,
  XML,
  SHX,
  DBF,
  GPKG,
  TIFF,
  TIF,
  GML,
  DXF,
  ZIP,
} from "@public/index";

interface FileTypeImages {
  [key: string]: any;
}

export const fileTypeImages: FileTypeImages = {
  txt: TXT,
  js: TXT,
  rtf: RTF,
  odt: ODT,
  html: HTML,
  htm: HTM,
  md: MD,
  xls: XLS,
  csv: CSV,
  ods: ODS,
  xlsm: XLSM,
  xlt: XLT,
  xltx: XLTX,
  odp: ODP,
  pps: PPS,
  ppsx: PPSX,
  key: KEY,
  pot: POT,
  potx: POTX,
  xml: XML,
  jsn: JSN,
  shx: SHX,
  dbf: DBF,
  gpkg: GPKG,
  tiff: TIFF,
  tif: TIF,
  gml: GML,
  dxf: DXF,
  pdf: PDF,
  docx: DOCX,
  doc: DOC,
  pages: DOC,
  geo: GEO,
  img: IMG,
  json: JSN,
  kml: KML,
  kmz: KMZ,
  prj: PRJ,
  shp: SHP,
  xlsx: XLSX,
  ppt: PPT,
  pptx: PPTX,
  close: CLOSE,
  download: DOWNLOAD,

  jpeg: IMG,
  jpg: IMG,
  png: IMG,
  bmp: IMG,
  gif: IMG,
  raw: IMG,
  psd: IMG,
  avif: IMG,
  webp: IMG,
  svg: IMG,
  heic: IMG,

  mp4: VID,
  mov: VID,
  wmv: VID,
  avi: VID,
  avchd: VID,
  flv: VID,
  f4v: VID,
  swf: VID,
  mkv: VID,
  webm: VID,
  "3gp": VID,
  mpeg: VID,
  ogg: VID,
  zip: ZIP,
  ts: VID,
  m4v: VID,
  mpg: VID,
  mxf: VID,
  rm: VID,
  rmvb: VID,
  vob: VID,
  ogv: VID,
  asf: VID,
  mts: VID,
};

// Function to get value by file extension key
export function getFileTypeImage(extension: string): string {
  if (Object.keys(fileTypeImages)?.includes(extension?.toLocaleLowerCase())) {
    return fileTypeImages?.[extension?.toLocaleLowerCase()];
  }
  return DOC;
}
